import { createServerFn } from "@tanstack/react-start";
import { authMiddleware } from "@/middleware/auth";
import { getCreditBalance } from "@super-resume-new/api/lib/credits";

export const getCredits = createServerFn({ method: "GET" })
  .middleware([authMiddleware])
  .handler(async ({ context }) => {
    if (!context.session?.user?.id) {
      return { balance: 0 };
    }
    const balance = await getCreditBalance(context.session.user.id);
    return { balance };
  });
